/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type AdminCell_user$ref = any;
type AdminList_lists$ref = any;
export type GrantAdminInput = {|
  clientMutationId?: ?string,
  email: string,
|};
export type grantAdminMutationVariables = {|
  input: GrantAdminInput
|};
export type grantAdminMutationResponse = {|
  +grantAdmin: ?{|
    +adminEdge: ?{|
      +node: ?{|
        +$fragmentRefs: AdminCell_user$ref
      |}
    |},
    +lists: {|
      +$fragmentRefs: AdminList_lists$ref
    |},
    +errors: ?$ReadOnlyArray<{|
      +key: string,
      +messages: $ReadOnlyArray<string>,
    |}>,
  |}
|};
export type grantAdminMutation = {|
  variables: grantAdminMutationVariables,
  response: grantAdminMutationResponse,
|};
*/


/*
mutation grantAdminMutation(
  $input: GrantAdminInput!
) {
  grantAdmin(input: $input) {
    adminEdge {
      node {
        ...AdminCell_user
        id
      }
    }
    lists {
      ...AdminList_lists
      id
    }
    errors {
      key
      messages
    }
  }
}

fragment AdminCell_lists on Lists {
  id
}

fragment AdminCell_user on User {
  id
  email
}

fragment AdminList_lists on Lists {
  ...AdminCell_lists
  adminUsers(first: 1000) {
    edges {
      node {
        id
        ...AdminCell_user
        __typename
      }
      cursor
    }
    pageInfo {
      endCursor
      hasNextPage
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input",
    "type": "GrantAdminInput!"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "key",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "messages",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1000
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "grantAdminMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GrantAdminPayload",
        "kind": "LinkedField",
        "name": "grantAdmin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserEdge",
            "kind": "LinkedField",
            "name": "adminEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "AdminCell_user"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Lists",
            "kind": "LinkedField",
            "name": "lists",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "AdminList_lists"
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootMutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "grantAdminMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "GrantAdminPayload",
        "kind": "LinkedField",
        "name": "grantAdmin",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserEdge",
            "kind": "LinkedField",
            "name": "adminEdge",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Lists",
            "kind": "LinkedField",
            "name": "lists",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": (v5/*: any*/),
                "concreteType": "UserConnection",
                "kind": "LinkedField",
                "name": "adminUsers",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": "adminUsers(first:1000)"
              },
              {
                "alias": null,
                "args": (v5/*: any*/),
                "filters": null,
                "handle": "connection",
                "key": "AdminList_adminUsers",
                "kind": "LinkedHandle",
                "name": "adminUsers"
              }
            ],
            "storageKey": null
          },
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": null,
    "metadata": {},
    "name": "grantAdminMutation",
    "operationKind": "mutation",
    "text": "mutation grantAdminMutation(\n  $input: GrantAdminInput!\n) {\n  grantAdmin(input: $input) {\n    adminEdge {\n      node {\n        ...AdminCell_user\n        id\n      }\n    }\n    lists {\n      ...AdminList_lists\n      id\n    }\n    errors {\n      key\n      messages\n    }\n  }\n}\n\nfragment AdminCell_lists on Lists {\n  id\n}\n\nfragment AdminCell_user on User {\n  id\n  email\n}\n\nfragment AdminList_lists on Lists {\n  ...AdminCell_lists\n  adminUsers(first: 1000) {\n    edges {\n      node {\n        id\n        ...AdminCell_user\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '2b323a70ea7a81011e6a09933d7bd660';

module.exports = node;
